module.exports = __webpack_public_path__ + "static/vivoki-2af0435c49fa1e1f9ffbafb2666d20b9.png";